(function () {
  var SESSION_KEY = 'laIntroPlayed';

  function initIntro() {
    var intro = document.querySelector('[data-la-intro]');
    if (!intro) return;

    if (window.sessionStorage.getItem(SESSION_KEY) || (window.Shopify && Shopify.designMode)) {
      intro.remove();
      return;
    }

    window.sessionStorage.setItem(SESSION_KEY, '1');

    window.setTimeout(function () {
      intro.remove();
    }, 2900);
  }

  function initMobileDrawer() {
    var burger = document.querySelector('[data-la-burger]');
    var drawer = document.querySelector('[data-la-drawer]');
    var closeBtn = document.querySelector('[data-la-drawer-close]');
    if (!burger || !drawer) return;

    burger.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) close();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initIntro();
    initMobileDrawer();
  });
})();
